export default __webpack_public_path__ + "static/media/F0001.7455dbb4.png";